import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import Axios from 'axios';
// register globally


// 按钮权限指令
//  按钮权限控制指令
Vue.directive('permission', {
  inserted: (el, binding)=>{
    const { value } = binding;
    // 判断当前用户是否拥有该按钮权限
    if (!checkPermission(value)) {
      el.parentNode.removeChild(el);
    }
  }
});
// 判断权限的函数
function checkPermission(permission) {
  var permissions = JSON.parse(localStorage.getItem('limits'))
  return permissions[permission];
}


const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
Vue.config.productionTip = false
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)
// 和代理做标识的对应, baseUrl
// Axios.defaults.baseURL = '/api'   需要直接访问public下的menus
Vue.prototype.$ajax = Axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
